<div [class.editmodecheck]="isEditMode" [class]="'investment-overview-widget ' + 'size-' + size">
  <div class="investment-overview-widget__header">
    <div class="investment-overview-widget__header-content">
      <div class="investment-overview-widget__title">{{ title }}</div>

      <div class="investment-overview-widget__actions">
        <!-- Navigation Controls -->
        <div class="investment-overview-widget__nav"
          *ngIf="!isEditMode && !isAddMode && investments.length > getItemsPerPage()">
          <div class="nav-btn" [class.disabled]="!canGoPrev()" (click)="prevPage($event)">
            <img src="assets/icons/arrow-white-left.svg" alt="Prev" />
          </div>
          <div class="nav-btn" [class.disabled]="!canGoNext()" (click)="nextPage($event)">
            <img src="assets/icons/arrow-white-right.svg" alt="Next" />
          </div>
        </div>

        <ng-container *ngIf="isEditMode">
          <div (click)="toggleSizeDropdown(index, $event)" class="investment-overview-widget__icon-container">
            <div class="investment-overview-widget__icon">
              <img class="investment-overview-widget__edit-icon" src="assets/icons/widget/pencil.svg" cdkOverlayOrigin
                #editTrigger="cdkOverlayOrigin" alt="Edit">
            </div>
          </div>

          <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
            [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
            [toggleSizeDropdown]="toggleSizeDropdown">
          </app-widget-edit>
        </ng-container>

        <ng-container *ngIf="isAddMode">
          <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
            (click)="addWidget.emit(); $event.stopPropagation()" />
        </ng-container>
      </div>
    </div>
  </div>

  <div class="investment-overview-widget__content">
    <div class="investment-overview-widget__grid">
      <div class="investment-overview-widget__column" *ngFor="let _ of getColumnsArray(); let colIndex = index">

        <div class="investment-overview-widget__item" *ngFor="let investment of getColumnInvestments(colIndex)"
          (click)="openModal(investment.companyName)">

          <div class="investment-overview-widget__item-info">
            <div class="investment-overview-widget__company-name">{{ investment.companyName }}</div>
            <div class="investment-overview-widget__amount">{{ investment.amount }}</div>
          </div>

          <div class="investment-overview-widget__item-stats"
            [ngClass]="{'investment-overview-widget__item-stats--large': size === 'half'}">
            <div class="investment-overview-widget__percentage-row">
              <img *ngIf="investment.isPositive" class="investment-overview-widget__arrow-icon"
                src="assets/icons/up-trend.svg" alt="Arrow Up">
              <img *ngIf="!investment.isPositive" class="investment-overview-widget__arrow-icon"
                src="assets/icons/up-trend-red.svg" alt="Arrow Down">
              <div class="investment-overview-widget__percentage" [class.positive]="investment.isPositive"
                [class.negative]="!investment.isPositive">
                {{ investment.percentageChange }}
              </div>
            </div>
            <div class="investment-overview-widget__chart-badge">
              <canvas #trendChart class="investment-overview-widget__mini-chart"></canvas>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>